const apiVersion = 'v1';

const getReports = async () => {
  try {
    const result = await window.axios.get(`/${apiVersion}/viewsupport/report`);

    const { data } = result.data;
    return data;
  } catch (err) {
    return err;
  }
};

const getScheduledReportsList = async () => {
  const result = await window.axios.get(`/${apiVersion}/reports/schedules`);

  const { data } = result.data;

  return data;
};

const getPortfolioSites = async () => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/sites/portfolio`
    );
    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const createScheduledReport = async (report) => {
  try {
    const response = await window.axios.post(
      `/${apiVersion}/reports/schedules`,
      report
    );
    const result = response?.data?.data;
    return result;
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteScheduledReport = async (reportId) => {
  try {
    const result = await window.axios.delete(
      `/${apiVersion}/reports/schedules/${reportId}`
    );

    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getScheduledReportById = async (reportId) => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/reports/schedules/${reportId}`
    );

    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const editScheduledReport = async (reportId, report) => {
  try {
    const result = await window.axios.put(
      `/${apiVersion}/reports/schedules/${reportId}`,
      report
    );

    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getReportTemplatesForCurrentUser = async () => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/reports/templates/for-current-user`
    );

    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
}

const getRecipientsForCurrentUser = async () => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/reports/schedules/recipients`
    );

    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
}

export default {
  getReports,
  getScheduledReportsList,
  getPortfolioSites,
  createScheduledReport,
  deleteScheduledReport,
  getScheduledReportById,
  editScheduledReport,
  getReportTemplatesForCurrentUser,
  getRecipientsForCurrentUser
};
